<div class="modal-content" data-testid="SUBSYS7_LOADER_BOX">
	<img data-testid="SUBSYS7_LOADER_IMG" [src]="LOADER_URL" alt="loading" class="logo-loading">
</div>